<template>
  <window-container class="product-category-window">
    <div class="title">
      Edit Category
    </div>
    <table>
      <tr>
        <td>Category</td>
        <td>
          <el-table
            ref="categoryTable"
            :data="categoryList"
            highlight-current-row
            @current-change="handleCurrentChange"
            :show-header="false"
            height="300"
            style="width:500px;">
            <el-table-column
              prop="name"
              label="Category Name"
              width="300">
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-button icon="el-icon-arrow-up" :disabled="scope.row.id === categoryList[0].id" @click="up(scope.row)"></el-button>
                <el-button icon="el-icon-arrow-down" :disabled="scope.row.id === categoryList[categoryList.length -1].id" @click="down(scope.row)"></el-button>
                <el-button icon="el-icon-delete" @click="del(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </td>
      </tr>
      <tr>
        <td>Change Name</td>
        <td>
          <el-input v-model="updateName" style="width:250px;"></el-input>
          <el-button @click="update">Update Category Name</el-button>
        </td>
      </tr>
      <tr>
        <td>New Category</td>
        <td>
          <el-input v-model="insertName" style="width:250px;"></el-input>
          <el-button @click="insert">Add New Category</el-button>
        </td>
      </tr>
    </table>
  </window-container>
</template>

<script>
export default {
  data () {
    return {
      categoryList: [],
      updateId: 0,
      updateName: '',
      insertName: ''
    }
  },
  mounted () {
    this.fetchCategoryList()
  },
  methods: {
    fetchCategoryList () {
      this.$http.get('/dbapi/category_list').then(data => {
        this.categoryList = data.list
      })
    },
    handleCurrentChange (row) {
      if (!!row) {
        this.updateId = row.id
        this.updateName = row.name
      }
    },
    insert () {
      if (!this.insertName) {
        return
      }
      this.$http.post('/dbapi/category_insert', {
        name: this.insertName,
        order_no: this.categoryList[this.categoryList.length - 1].order_no + 1
      }).then(data => {
        this.insertName = ''
        this.fetchCategoryList()
      })
    },
    update () {
      if (!this.updateName) {
        return
      }
      this.$http.post('/dbapi/category_update', {
        id: this.updateId,
        name: this.updateName
      }).then(data => {
        this.updateName = ''
        this.fetchCategoryList()
      })
    },
    up (row) {
      this.$http.post('/dbapi/category_order_up', {
        order_no: row.order_no
      }).then(data => {
        this.fetchCategoryList()
      })
    },
    down (row) {
      this.$http.post('/dbapi/category_order_down', {
        order_no: row.order_no
      }).then(data => {
        this.fetchCategoryList()
      })
    },
    del (row) {
      this.$confirm(`You sure you want to delete it？[${row.name}]`, 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/category_del', {
          id: row.id
        }).then(data => {
          this.fetchCategoryList()
        })
      })
    },
    close () {
      this.$close()
    }
  }
}
</script>

<style>
.product-category-window {
  background-color: #fff;
}
.product-category-window .title {
  background-color: #b0c8f5;
  font-size: 16px;
  font-weight: bold;
  padding: 4px 10px;
}
.product-category-window table {
  border-spacing: 0;
}
.product-category-window table td {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.product-category-window .el-table td {
  padding: 4px 0;
}
</style>